import { render, staticRenderFns } from "./FigmaAiModal.vue?vue&type=template&id=7ed67af2&scoped=true&"
import script from "./FigmaAiModal.vue?vue&type=script&lang=js&"
export * from "./FigmaAiModal.vue?vue&type=script&lang=js&"
import style0 from "./FigmaAiModal.vue?vue&type=style&index=0&id=7ed67af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed67af2",
  null
  
)

export default component.exports